import React,{ useEffect, useState } from 'react'
import { Divider, Input, Select, Spin, Tabs  } from 'antd';
import { DetailContainer, FormItem, FormikForm } from '../../../StyledComponents/CreateKeyAccountManager'
import { HeadContainer } from '../../../StyledComponents/Dashboard';
import { LeftContent ,BottomContent ,DetailRow} from "../../../StyledComponents/Markup"
import {  MidContent, RightContent, RowValue, TableInput, TableItem, TDItem, THeadItem, THItem, Title, TitleDiv, TitleRow, TopButtonDiv, TopContent, TRItem, TableFilter } from '../../../StyledComponents/RateManagement';
import SubmitButton from '../Common/SubmitButton';
import { ErrorMessage } from 'formik';
import { move_rate_archive } from '../../../store/Admin/RateManagement/RateManagementSlice';
import { useDispatch } from 'react-redux';
import { countries_list, shipment_list, shipport_list, state_list, updatenotificationdata } from '../../../store/Admin/Common/CommonSlice';
import { httpinstance } from '../../../axios/api';
import styled from 'styled-components';
import * as Yup from 'yup'
import { formatDate, GetContainerSizeLabel, handleKeyPress } from '../../../functions/Utils';
import { SpinContainer, TextAreaItem } from '../../../StyledComponents/Queries';
import { useLocation } from 'react-router-dom';
import SelectSearchCountry from '../Common/SelectSearchCountry';
import SelectSearchState from '../Common/SelectSearchState';
import SelectItem from '../Common/SelectItem';
import SimpleInput from '../Common/SimpleInput';

const { Option } = Select;
const FUEL_TYPE = [
    { label: "CNG", value: "CNG" },
    { label: "Diesel", value: "DIESEL" },
    { label: "Electric", value: "ELECTRIC" }
  ];
  

  const validationSchema = Yup.object().shape({
    country:  Yup.array().of(Yup.string()).nullable().min(1, 'country is required'),
    name: Yup.string().nullable().required('Name is required'),
    fuel: Yup.string().nullable().required("Fuel is required"),
    length: Yup.number()
        .nullable()
        .min(1, 'Length must be greater than 0')
        .required('Length is required'),
    breadth: Yup.number()
        .nullable()
        .min(1, 'Breadth must be greater than 0')
        .required('Breadth is required'),
    height: Yup.number()
        .nullable()
        .min(1, 'Height must be greater than 0')
        .required('Height is required'),
    cbmMax: Yup.number()
        .nullable()
        .min(1, 'CBM Max must be greater than 0')
        .required('CBM Max is required'),
    weightMax: Yup.number()
        .nullable()
        .min(1, 'Weight Max must be greater than 0')
        .required('Weight Max is required'),
    kmRange: Yup.number().nullable().min(1, 'Weight Max must be greater than 0').required('kmRange Rate is required'),
});



function VehicleDetailPage(props) {
    const dispatch = useDispatch()
    const [spinner, setSpinner] = useState(false);
    const [loading, setLoading] = useState(true);
    const [type, setType] = useState(props.type);
    const [state, setState] = useState({
        countrie: [],
        state_list: [],
    });

    const location = useLocation();
    const [isLoad, setIsLoad] = useState(true);
    useEffect(()=> {
        if(location.pathname === '/rate-management'){
        if(isLoad === false){
            props.setPageType("table")
        }else {
            setIsLoad(false)
        }
        }
    },[location])

    useEffect(()=>{
        dispatch(countries_list())
        .then(res=>{
            // console.log('login res => ',res);
            if(res?.payload?.status === 200 ){
                const countries = res?.payload?.data?.data.filter((item, index, arr) => {
                    return arr.findIndex(t => t.country_name === item.country_name) === index;
                  });
                //   console.log(countries);
                setState((prevState) => {
                    return {
                        ...prevState,
                        countries: countries
                    }
                })
                setLoading(false)
            }
        })
        .catch(err=>{
            console.error(err);
        })

        dispatch(state_list())
        .then(res=>{
            // console.log('login res => ',res);
            if(res?.payload?.status === 200 ){
                setState((prevState) => {
                    return {
                        ...prevState,
                        state_list: res?.payload?.data?.data
                    }
                })
                setLoading(false)
            }
        })
        .catch(err=>{
            console.error(err);
        })
        
    },[])

    const handleCancel = (resetForm) => {
        setType("view")
        props.setType("view")
        resetForm()
    }

    const handleEdit = () => {
        setType("edit")
        props.setType("edit")
    }
    const handleSelectChange = (e,name,setFieldValue)=> {
        setFieldValue([name],e)
    }

      

    const initialValues = {
      country: props.instance?.country ? props.instance?.country : [],
      name: props?.instance?.name ? props?.instance?.name : null,
      length: props?.instance?.length ? props?.instance?.length : 1,
      fuel: props?.instance?.fuel ? props?.instance?.fuel : '',
      breadth: props?.instance?.breadth ? props?.instance?.breadth : 1,
      height: props?.instance?.height ? props?.instance?.height : 1,
      cbmMax: props?.instance?.cbmMax ? props?.instance?.cbmMax : 1,
      weightMax: props?.instance?.weightMax ? props?.instance?.weightMax : 1,
      kmRange: props?.instance?.kmRange ? props?.instance?.kmRange :  1,
      id: props.instance?._id ? props.instance?._id : "",
    };
   
  

    

    if(loading){
        return (
                <SpinContainer className='user-quote'>
                    <Spin />
                </SpinContainer>
            )
    }else {
        return (
            <FormikForm
                initialValues={initialValues}
                validationSchema={validationSchema}

                onSubmit={async(values,{resetForm}) => {
                    const data = {
                        ...values,  
                        length: Number(values.length),
                        breadth: Number(values.breadth),
                        height: Number(values.height),
                        cbmMax: Number(values.cbmMax),
                        weightMax: Number(values.weightMax),
                        kmRange: Number(values.kmRange),
                    };
                    setSpinner(true)
                    let states = values.states
                    if(values.country !== "India" && values.country !== "INDIA"){
                        states = ""
                    }
                    try {
                        const result = type === 'edit'
                         ?
                        await httpinstance.patch(
                            `vehicle-types/${values.id}`,
                            data
                            )
                        :
                        await httpinstance.post(
                            `vehicle-types`,
                            data
                            );
                            
                            if(result?.data?.statusCode === 200 || result?.data?.statusCode === 201){
                                let data = {
                                    message : result.data.message,
                                    statusCode: 200,
                                    success: result.data.status
                                }
                                dispatch(updatenotificationdata(data))
                                setSpinner(false);
                                resetForm()
                                props.setCallList(true)
                                props.setPageType("table")
                            }
                    } catch (error) {
                        console.log(error);
                        setSpinner(false);
                    }
                    
            }}
            >
            {({ values,setFieldValue, handleChange, handleBlur, resetForm,errors }) => (
                <FormItem>
                    <DetailContainer>
                    <HeadContainer className='flexEnd'>
                    
                        <TopButtonDiv className='mb-3'>
                            {type === 'edit' || type === 'create' ? 
                            <>  {type === 'edit' ? <SubmitButton type='button' title="Cancel" is_icon={false} handleClick={()=> handleCancel(resetForm)} /> : null}
                                <SubmitButton type='submit' title="save" is_save={true} loading={spinner} />
                            </>
                            : <SubmitButton type="button" title="Edit" icon_type="edit" handleClick={()=> handleEdit()} /> }
                        </TopButtonDiv>
                    
                    </HeadContainer>
                <BottomContent>
                <TopContent>
                    <LeftContent>
                        <DetailRow>
                            <TitleDiv>
                            <TitleRow>Country*</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <SelectSearchCountry mode={true} name="country" value={values.country} setFieldValue={setFieldValue} options={state.countries} 
                                width="100%" bradius="8px" placeholder="Country" />
                                <ErrorMessage name="country" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                           
                            <RowValue>{values.country ? values?.country?.join(' , ') : '-'}</RowValue> }
                        </DetailRow>
                        <DetailRow>
                            <TitleDiv>
                                <TitleRow>Name</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <SimpleInput
                                    id="name"
                                    name="name"
                                    value={values?.name}
                                    size="large"
                                    placeholder='Name'
                                    handleChange={handleChange}
                                />
                                <ErrorMessage name="name" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue>{values?.name}</RowValue> }
                        </DetailRow>
                        <DetailRow 
                        style={{
                            flexFlow: "column",
                            width: "100%"
                        }}
                        >
                            <TitleDiv>
                                <TitleRow>Fuel</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                              <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "50%",
                            flexShrink: 0, 
                            flexGrow: 1,
                          }}
                        >
                          
                                 <SelectItem   width={160}bradius="8px"  value={values?.fuel} setFieldValue={setFieldValue} name='fuel' placeholder='Fuel' handleChange={handleChange} options={FUEL_TYPE} />
                                <ErrorMessage name="fuel" component="div" style={{ color: 'red',fontSize: '12px'}} />
                            </div>
                            :
                            <RowValue>{values?.fuel}</RowValue> }
                        </DetailRow>
                        <DetailRow>
                            <TitleDiv>
                                <TitleRow>length</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <Input
                                    id="length"
                                    name="length"
                                    value={values.length}
                                    onBlur={handleBlur}
                                    size="large"
                                    placeholder='Length'
                                    onChange={handleChange}
                                    onKeyPress={handleKeyPress}
                                />
                                <ErrorMessage name="length" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue>{values.length}</RowValue> }
                        </DetailRow>
                        <DetailRow>
                            <TitleDiv>
                                <TitleRow>breadth</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <Input
                                    id="breadth"
                                    name="breadth"
                                    value={values.breadth}
                                    onBlur={handleBlur}
                                    size="large"
                                    placeholder='Breadth'
                                    onChange={handleChange}
                                    onKeyPress={handleKeyPress}
                                />
                                <ErrorMessage name="breadth" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue>{values.breadth}</RowValue> }
                        </DetailRow>
                        <DetailRow>
                            <TitleDiv>
                                <TitleRow>height</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <Input
                                    id="height"
                                    name="height"
                                    value={values.height}
                                    onBlur={handleBlur}
                                    size="large"
                                    placeholder='Height'
                                    onChange={handleChange}
                                    onKeyPress={handleKeyPress}
                                />
                                <ErrorMessage name="height" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue>{values.height}</RowValue> }
                        </DetailRow>
                        <DetailRow>
                            <TitleDiv>
                                <TitleRow>CbmMax</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <Input
                                    id="cbmMax"
                                    name="cbmMax"
                                    value={values.cbmMax}
                                    onBlur={handleBlur}
                                    size="large"
                                    placeholder='CbmMax'
                                    onChange={handleChange}
                                    onKeyPress={handleKeyPress}
                                />
                                <ErrorMessage name="cbmMax" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue>{values.cbmMax}</RowValue> }
                        </DetailRow>
                        <DetailRow>
                            <TitleDiv>
                                <TitleRow>WeightMax</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <Input
                                    id="weightMax"
                                    name="weightMax"
                                    value={values.weightMax}
                                    onBlur={handleBlur}
                                    size="large"
                                    placeholder='WeightMax'
                                    onChange={handleChange}
                                    onKeyPress={handleKeyPress}
                                />
                                <ErrorMessage name="weightMax" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue>{values.weightMax}</RowValue> }
                        </DetailRow>
                        <DetailRow>
                            <TitleDiv>
                                <TitleRow>KmRange</TitleRow>
                            </TitleDiv>
                            {type === 'edit' || type === 'create' ?
                            <div style={{ display: 'flex',flexDirection: 'column', width: '50%'}}>
                                <Input
                                    id="kmRange"
                                    name="kmRange"
                                    value={values.kmRange}
                                    onBlur={handleBlur}
                                    size="large"
                                    placeholder='KmRange'
                                    onChange={handleChange}
                                    onKeyPress={handleKeyPress}
                                />
                                <ErrorMessage name="kmRange" component="div" style={{ color: 'red',fontSize: '12px' }} />
                            </div>
                            :
                            <RowValue>{values.kmRange}</RowValue> }
                        </DetailRow>
                     
                    </LeftContent>
                   
                </TopContent>
                </BottomContent>
                
            </DetailContainer>
                </FormItem>
            )}
            </FormikForm>
            
        )
    }
}

export default VehicleDetailPage


const ItemSelect = styled(Select)`
    & .ant-select-selector {
        border-radius: 8px !important;
        padding: ${({ pdg }) => pdg? pdg : "unset"};
    }
    & .ant-select-selection-placeholder {
        color: #d9d9d9 !important;
        font-size: 16px;
        font-weight: 400;
    }
    & .ant-select-arrow {
        color: #d9d9d9 !important
    }
    /* & .ant-select-selection-item {
        font-family: 'Rubik';
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
    } */
`